import React from 'react'

const WidthIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="58.104" height="34.491" viewBox="0 0 58.104 34.491"><g opacity=".5" stroke="#fff" strokeWidth="1.4" fill="none"><path d="M33.629 24.7l-31.039-.553v-14.813l12.171-8.576 18.23 4.557 24.414 3.714v12.318zM33.676 5.69l-.443 19.066-10.187-.207.139-10.273h-9.543v9.986"/></g><path d="M1.734 31.203l32.322.732" stroke="#d59300" strokeWidth="2" fill="none"/><path d="M3.234 28.703v5l-3.235-2.092zM33.348 29.381l-.175 4.995 3.305-1.977z" fill="#d59300"/></svg>
  )
}
export default WidthIcon;